import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const AllVendor = lazy(() => import("../pages/all-vendor"));
const AddVendor = lazy(() => import("../pages/add-vendor"));

export const VendorManagementRouter = [
  {
    path: "/vendor-management",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllVendor />
          </Suspense>
        ),
      },
      {
        path: "create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddVendor />
          </Suspense>
        ),
      },
      {
        path: "edit-vendor/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddVendor />
          </Suspense>
        ),
      },
    ],
  },
];
